export const isRunningTests = import.meta.env.NODE_ENV === 'test';
export const isRunningStorybook = import.meta.env.STORYBOOK === 'true';
export const isRunningOnMac = navigator.userAgent.indexOf('Mac') !== -1;
